import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { GET_MY_PROFILE, REGISTRAR_DETAIL } from 'store/actions/types';
import 'utils/handler';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { checkBlockedCountry, updateClicks } from './store/actions/lead.action';
import store from './store/store';

import { decryptData, getLocalStorageValue, history, localStorageKeyValue, myCountryDetails, queryHandler, removeLocalStorageValue, setLocalStorageValue } from './utils/handler';
let loadBB = false;
let domainName: string | null = null;
checkBlockedCountry();
myCountryDetails();

const query = new URLSearchParams(history.location.search);
// console.log('query', history, window.location.pathname, document.referrer)
// const queryString = window.location.search;
// console.log(queryString);

if (history.location && history.location.search) {
  const registrarUID: string | null = query.get('registrarId') || getLocalStorageValue(localStorageKeyValue.registrarUID);
  domainName = query.get('domainName') || query.get('domain') || getLocalStorageValue(localStorageKeyValue.domainName);
  if (domainName) {
    setLocalStorageValue(localStorageKeyValue.domainName, domainName);
  }
  let promoCode = query.get(localStorageKeyValue.promoCode);
  if (promoCode) {
    localStorage.setItem(localStorageKeyValue.promoCode, promoCode);
  }
  queryHandler(query);
  // if (query) {
  //   history.push(queryParams.redirectUrl);

  if (registrarUID) {
    setLocalStorageValue(localStorageKeyValue.registrarUID, registrarUID || '');
    updateClicks(registrarUID, domainName);
  }
  if (registrarUID === '2db2e3f7-d348-4a3d-9f2c-dd8533c3cc09') {
    window.location.href = 'https://saw.com/upgrades';
  } else {
    loadBB = true;
  }
} else {
  loadBB = true;
}
// save registrarDetails in local storage and show it even after refresh
let registrarObj = getLocalStorageValue(localStorageKeyValue.registrarDetail);
if (registrarObj) {
  let registrarDetails = JSON.parse(registrarObj);
  store.dispatch({ type: REGISTRAR_DETAIL, payload: registrarDetails });
  // UID && registrarDetails(UID, domainName);
}
let myProfile = getLocalStorageValue(localStorageKeyValue.myProfile);
if (myProfile !== decryptData(myProfile)) {
  store.dispatch({ type: GET_MY_PROFILE, payload: decryptData(myProfile) });
} else {
  removeLocalStorageValue(localStorageKeyValue.myProfile);
}

if (loadBB) {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById('root'),
  );
}

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
